import { render, staticRenderFns } from "./PreviousReviews.vue?vue&type=template&id=f7e01b94&scoped=true&"
import script from "./PreviousReviews.vue?vue&type=script&lang=js&"
export * from "./PreviousReviews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7e01b94",
  null
  
)

export default component.exports